module.exports = __webpack_public_path__ + "static/media/answers-profile-pic-1.a6a44d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/answers-profile-pic-1.png
// module id = 1051
// module chunks = 0